import { Pipe, PipeTransform } from '@angular/core';
import { Utils } from '../services/utils.service';

@Pipe({name: 'ssn'})
export class SocialSecurityNumberPipe implements PipeTransform {
  constructor(private utils: Utils) {
  }

  transform(value: string): string {
    let mask: string = '';

    if (value !== null && typeof value === 'string') {
      // get only the numbers
      value = this.utils.getOnlyDigitsFromString(value);

      for (let x = 0; x < value.length; x++) {
        if (x <= 4) {
          mask += 'x';

          if (x === 2 || x === 4) {
            mask += '-';
          }
        } else {
          mask += value[x];
        }
      }
    }

    return mask;
  }
}
